import { IApiService } from '@/api';
import {
    IRelocationLimitFormData, EditedRelocationLimit, Channel,
    ComponentData, RelocationLimit
} from '.';

export class RelocationLimitFormData
    implements IRelocationLimitFormData {

    public readonly closeForm: ((success: boolean) => void);
    public relocationLimit: EditedRelocationLimit | null = null;

    public formTitle?: string;
    public readonly apiService: IApiService;
    private readonly _parent: ComponentData;

    constructor(
        parent: ComponentData,
        closeForm: ((success: boolean) => void),
        apiService: IApiService,
        relocationLimit: RelocationLimit | null = null
    ) {
        if (!parent) { throw new Error('parent is not set'); }
        if (!closeForm) { throw new Error('closeForm is not set'); }
        if (!apiService) { throw new Error('apiService is not set'); }

        this._parent = parent;
        this.closeForm = closeForm;
        this.apiService = apiService;

        if (relocationLimit) {
            this.relocationLimit = EditedRelocationLimit.fromRelocationLimit(relocationLimit);
        }
    }

    public get channels(): Promise<Channel[]> {
        let result: Promise<Channel[]>;
        if (this._parent.promiseLoadChannels) {
            result = this._parent.promiseLoadChannels;
        } else {
            result = new Promise((r, f) => r([]));
        }
        return result;
    }

    public async save(): Promise<void> {
        await this._parent.save(this.apiService, this.relocationLimit!);
    }
}
